import { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { usePageShellContext } from '../shell/PageShellProvider';
import type { PageShellConfig } from '../shell/pageShellTypes';

/**
 * Register page chrome (title, actions, filters) with the application shell.
 * Unset fields use route defaults from nav config (SAP-style manifest + override).
 */
export function usePageShell(config: PageShellConfig): void {
  const { pathname } = useLocation();
  const { setPageShell, clearPageShell } = usePageShellContext();
  const configRef = useRef(config);

  useLayoutEffect(() => {
    configRef.current = config;
    setPageShell(configRef.current);
    return () => clearPageShell();
  }, [
    pathname,
    setPageShell,
    clearPageShell,
    config.title,
    config.subtitle,
    config.breadcrumb,
    config.hideChrome,
    config.filters,
    config.actions,
  ]);
}
